export const baseRoute = '/o/:orgId';

export const mailroomDashboardRoute = 'dashboard';

export const mailroomListRoute = 'mailrooms';

export const parcelActivityRoute = 'mailroomParcelActivity';

export const rolesRoute = 'roles';
